import { useEffect, useRef, useState } from 'react';
import { FaBook, FaGlobe, FaCheckCircle } from 'react-icons/fa';
import './OurStory.css';

const OurStory = ({ 
  title = "About ALNoor Tutors",
  badge = "Our Story",
  paragraphs = []
}) => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const milestones = [
    { year: '2000', title: 'Founded', description: 'Started as an offline Quran school' },
    { year: '2005', title: 'Online Transition', description: 'Moved online to reach more students' },
    { year: '2010', title: 'Global Expansion', description: 'Expanded to multiple countries' },
    { year: '2024', title: 'Today', description: 'Serving thousands of students worldwide' }
  ];

  return (
    <section 
      ref={sectionRef}
      className={`our-story-section ${isVisible ? 'visible' : ''}`}
      id="our-story"
    >
      <div className="container">
        {/* Header */}
        <div className="our-story-header">
          <div className="story-header-icon-wrapper">
            <FaBook className="story-header-icon" />
          </div>
          <span className="our-story-badge">{badge}</span>
          <h2 className="our-story-title">{title}</h2>
        </div>

        <div className="our-story-content-wrapper">
          {/* Story Content */}
          <div className="our-story-content">
            <div className={`story-text-content ${isVisible ? 'visible' : ''}`}>
              {paragraphs.map((paragraph, index) => (
                <div key={index} className="story-paragraph">
                  <div className="paragraph-icon">
                    <FaCheckCircle />
                  </div>
                  <p>{paragraph}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Milestones Timeline */}
          <div className={`story-milestones ${isVisible ? 'visible' : ''}`}>
            <h3 className="milestones-title">Our Journey</h3>
            <div className="timeline">
              {milestones.map((milestone, index) => (
                <div
                  key={index}
                  className={`timeline-item ${isVisible ? 'visible' : ''}`}
                  style={{ animationDelay: `${index * 0.15}s` }}
                >
                  <div className="timeline-marker">
                    <div className="timeline-dot"></div>
                    {index < milestones.length - 1 && <div className="timeline-line"></div>}
                  </div>
                  <div className="timeline-content">
                    <div className="timeline-year">{milestone.year}</div>
                    <h4 className="timeline-title">{milestone.title}</h4>
                    <p className="timeline-description">{milestone.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Global Presence */}
        <div className={`global-presence ${isVisible ? 'visible' : ''}`}>
          <div className="global-presence-icon">
            <FaGlobe />
          </div>
          <h3>Global Presence</h3>
          <p>
            ALNoor Tutors is based in the United States, the UAE, and Pakistan. 
            Classes are taking place in the USA, Canada, Australia, UK, France, Germany, Norway, 
            Ireland, Switzerland, Italy, Turkey, Sweden, Denmark, Finland, Greece, Singapore, 
            Hong Kong, Belgium, Spain, Oman, Bahrain, Kuwait, Saudi Arabia, Qatar and UAE, 
            and lots of other countries.
          </p>
        </div>
      </div>
    </section>
  );
};

export default OurStory;
